export const projects = [
  {
    title: 'Travel Blog',
    description:
      'Built a Fullstack Travel Blog, using React with Javascript for the Frontend and NodeJs with MongoDB for the backend, the blog is currently hosted with Heroku.',
      imgUrl: './images/travelBlog.png',
    id: 1,
    gitUrl: 'https://github.com/anlsim/travel-blog',
    tools: [
      {
        name: '',
        fAwasome: 'fab fa-react',
      },
      {
        name: '',
        fAwasome: 'fab fa-js-square',
      },
      {
        name: '',
        fAwasome: 'fab fa-node',
      },
      {
        name: 'Mongo',
        fAwasome: '',
      },
      {
        name: '',
        fAwasome: 'fab fa-sass',
      },
      {
        name: '',
        fAwasome: 'fab fa-bootstrap',
      },
    ],
    linkUrl:
      'https://warm-escarpment-05416.herokuapp.com/register',
  },
  {
    title: 'Personal Portfolio',
    description:
      'Built a web portfolio to show projects, skills, and other relevant information. Used React with JavaScript for version 1, and upgraded to TypeScript for version 2.',
    imgUrl: './images/portfolio.png',
    id: 1,
    gitUrl:
      'https://github.com/anlsim/anlsim.github.io',
    tools: [
      {
        name: '',
        fAwasome: 'fab fa-react',
      },
      {
        name: '',
        fAwasome: 'fab fa-sass',
      },

      {
        name: '',
        fAwasome: 'fab fa-bootstrap',
      },
    ],
    linkUrl: 'https://anlsim.github.io/',
  },
  {
    title: 'Web Marks',
    description:
      'Built a web application that allows people to save and organize web URLs on boards based on specific subjects or collections.',
    imgUrl: './images/webMarks.png',
    id: 2,
    gitUrl: 'https://github.com/anlsim/WebMarks',
    tools: [
      {
        name: 'C#',
        fAwasome: '',
      },
      {
        name: 'ASP',
        fAwasome: '',
      },
      {
        name: 'MVC',
        fAwasome: '',
      },
      {
        name: '',
        fAwasome: 'fab fa-css3-alt',
      },
      {
        name: '',
        fAwasome: 'fab fa-bootstrap',
      },
    ],
    linkUrl: '',
  },
  {
    title: 'Task Tracker',
    description:
      'Team project to build a web application to help organize and keep track of tasks. Redesigned the View. Added new features to optimize the project.',
    imgUrl: './images/taskTracker.png',
    id: 3,
    gitUrl: 'https://github.com/anlsim/TimeTracker',
    tools: [
      {
        name: 'C#',
        fAwasome: '',
      },
      {
        name: 'ASP',
        fAwasome: '',
      },
      {
        name: 'MVC',
        fAwasome: '',
      },
      {
        name: '',
        fAwasome: 'fab fa-css3-alt',
      },
      {
        name: '',
        fAwasome: 'fab fa-bootstrap',
      },
    ],
    linkUrl: '',
  },
  {
    title: 'Photography Portfolio',
    description:
      'Personal photography portfolio. Built only with HTML and Bootstrap as a helper for styles.',
    imgUrl: './images/photoWebsite.png',
    id: 4,
    gitUrl:
      'https://github.com/anlsim/photography_website',
    tools: [
      {
        name: '',
        fAwasome: 'fab fa-html5',
      },
      {
        name: '',
        fAwasome: 'fab fa-css3-alt',
      },
      {
        name: '',
        fAwasome: 'fab fa-bootstrap',
      },
    ],
    linkUrl:
      'https://anlsim.github.io/photography_website/',
  },
]